module.exports = __webpack_public_path__ + "img/parameters.59743f4f.svg";